export const ACCESSORIALS = [
  {
    value: 'cfs_pickup',
    rate_to_carrier: 15,
    rate_to_shipper: 25,
    description: 'CFS Pick Up',
    localizeDescription: 'CFS_PICK_UP',
    label: 'CFS',
    localizeLabel: 'CFS_PICKUP',
    icon_slug: 'icon-2',
    picture_url: '/img/accessorials/cfs.png',
    dark_icon_slug_url: '/img/accessorials/cfs-dark.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
    required_documents: ['do'],
  },
  {
    value: 'cfs_delivery',
    rate_to_carrier: 15,
    rate_to_shipper: 25,
    description: 'CFS Delivery',
    localizeDescription: 'CFS_DELIVERY',
    label: 'CFS',
    localizeLabel: 'CFS_DELIVERY',
    icon_slug: 'icon-2',
    picture_url: '/img/accessorials/cfs.png',
    dark_icon_slug_url: '/img/accessorials/cfs-dark.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
    required_documents: ['do'],
  },
  {
    value: 'fsc',
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    description: 'Fuel Surcharge',
    localizeDescription: 'FUEL_SURCHARGE',
    label: 'fsc',
    localizeLabel: 'FSC',
    icon_slug: 'icon-25',
    picture_url: '/img/accessorials/cfs.png',
    dark_icon_slug_url: '/img/accessorials/cfs-dark.png',
    meta_data: {
      cost: {
        type: 'number',
        label: 'Fuel Cost (Dollars)',
        min: 0,
      },
    },
    include_in_offer: true,
    include_in_booking: false,
  },
  {
    value: 'two_man',
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    description: 'Two Man',
    localizeDescription: 'TWO_MAN',
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-17',
    picture_url: '/img/accessorials/lumper.png',
    dark_icon_slug_url: '/img/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: {
        type: 'number',
        label: 'Total duration (in minutes)',
        min: 30,
      },
    },
    include_in_booking: true,
  },
  {
    value: 'two_man_b2c',
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    description: 'Two Man B2C',
    localizeDescription: 'TWO_MAN_B2C',
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-21',
    picture_url: '/img/accessorials/lumper.png',
    dark_icon_slug_url: '/img/lumper.png',
    include_in_offer: false,
    include_in_booking: true,
  },
  {
    value: 'safety_vest',
    rate_to_carrier: 15,
    rate_to_shipper: 25,
    description: 'Safety Vest',
    localizeDescription: 'SAFETY_VEST',
    label: 'Safety Vest',
    localizeLabel: 'SAFETY_VEST',
    icon_slug: 'icon-3',
    picture_url: '/img/accessorials/lumper.png',
    dark_icon_slug_url: '/img/accessorials/lumper.png',
    include_in_offer: true,
    include_in_booking: true,
  },
  {
    value: 'debris_removal',
    rate_to_carrier: 15,
    rate_to_shipper: 25,
    description: 'Debris Removal',
    localizeDescription: 'DEBRIS_REMOVAL',
    label: 'Debris Removal',
    localizeLabel: 'DEBRIS_REMOVAL',
    icon_slug: 'icon-17',
    picture_url: '/img/accessorials/lumper.png',
    dark_icon_slug_url: '/img/accessorials/lumper.png',
    include_in_offer: true,
    include_in_booking: true,
  },
  {
    value: 'pickup_wait_time',
    rate_to_carrier: 29.25,
    rate_to_shipper: 100,
    description: 'Wait Time Pickup',
    localizeDescription: 'WAIT_TIME_PICKUP',
    label: 'Wait Time Pickup',
    localizeLabel: 'WAIT_TIME_PICKUP',
    icon_slug: 'icon-17',
    picture_url: '/img/accessorials/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: {
        wait_enabled: true,
        type: 'number',
        label: 'Total duration (in minutes)',
        min: 30,
      },
    },
    include_in_booking: false,
  },
  {
    value: 'delivery_wait_time',
    rate_to_carrier: 29.25,
    rate_to_shipper: 100,
    description: 'Wait Time Delivery',
    localizeDescription: 'WAIT_TIME_DELIVERY',
    label: 'Wait Time Delivery',
    localizeLabel: 'WAIT_TIME_DELIVERY',
    icon_slug: 'icon-17',
    picture_url: '/img/accessorials/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: {
        wait_enabled: true,
        type: 'number',
        label: 'Total duration (in minutes)',
        min: 30,
      },
    },
    include_in_booking: false,
  },
  {
    value: 'ceva_customer_pickup_wait_time',
    rate_to_carrier: 29.25,
    rate_to_shipper: 38.0,
    description: 'Wait Time Pickup - CEVA Customer',
    localizeDescription: 'WAIT_TIME_PICKUP_-_CEVA_CUSTOMER',
    label: 'Wait Time Pickup - CEVA Customer',
    localizeLabel: 'WAIT_TIME_PICKUP_-_CEVA_CUSTOMER',
    picture_url: '/img/accessorials/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: {
        wait_enabled: true,
        type: 'number',
        label: 'Total duration (in minutes)',
        min: 30,
      },
    },
    include_in_booking: false,
  },
  {
    value: 'ceva_customer_delivery_wait_time',
    rate_to_carrier: 29.25,
    rate_to_shipper: 38.0,
    description: 'Wait Time Delivery - CEVA Customer',
    localizeDescription: 'WAIT_TIME_DELIVERY_-_CEVA_CUSTOMER',
    label: 'Wait Time Delivery - CEVA Customer',
    localizeLabel: 'WAIT_TIME_DELIVERY_-_CEVA_CUSTOMER',
    icon_slug: 'icon-14',
    picture_url: '/img/accessorials/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: {
        wait_enabled: true,
        type: 'number',
        label: 'Total duration (in minutes)',
        min: 30,
      },
    },
    include_in_booking: false,
  },
  {
    value: 'ceva_station_pickup_wait_time',
    rate_to_carrier: 29.25,
    rate_to_shipper: 38.0,
    description: 'Wait Time Pickup - CEVA Station',
    localizeDescription: 'WAIT_TIME_PICKUP_-_CEVA_STATION',
    label: 'Wait Time Pickup - CEVA Station',
    localizeLabel: 'WAIT_TIME_PICKUP_-_CEVA_STATION',
    icon_slug: 'icon-14',
    picture_url: '/img/accessorials/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: {
        wait_enabled: true,
        type: 'number',
        label: 'Total duration (in minutes)',
        min: 30,
      },
    },
    include_in_booking: false,
  },
  {
    value: 'ceva_station_delivery_wait_time',
    rate_to_carrier: 29.25,
    rate_to_shipper: 38.0,
    description: 'Wait Time Delivery - CEVA Station',
    localizeDescription: 'WAIT_TIME_DELIVERY_-_CEVA_STATION',
    label: 'Wait Time Delivery - CEVA Station',
    localizeLabel: 'WAIT_TIME_DELIVERY_-_CEVA_STATION',
    icon_slug: 'icon-14',
    picture_url: '/img/accessorials/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: {
        wait_enabled: true,
        type: 'number',
        label: 'Total duration (in minutes)',
      },
    },
    include_in_booking: false,
  },
  {
    value: 'driver_assist',
    rate_to_carrier: 100,
    rate_to_shipper: 83.33,
    description: 'Driver Assist',
    localizeDescription: 'DRIVER_ASSIST',
    label: 'Driver Assist',
    localizeLabel: 'DRIVER_ASSIST',
    icon_slug: 'icon-32',
    picture_url: '/img/accessorials/lumper.png',
    include_in_offer: false,
    meta_data: {
      duration: { type: 'number' },
    },
  },
  {
    value: 'pickup_attempt',
    rate_to_carrier: 29.93,
    rate_to_shipper: 31.5,
    description: 'Pickup Attempt',
    localizeDescription: 'PICKUP_ATTEMPT',
    label: 'Pickup Attempt',
    localizeLabel: 'PICKUP_ATTEMPT',
    icon_slug: 'icon-21',
    picture_url: '/img/accessorials/residential.png',
    include_in_offer: false,
    include_in_booking: false,
  },
  {
    value: 'delivery_attempt',
    rate_to_carrier: 29.93,
    rate_to_shipper: 31.5,
    description: 'Delivery Attempt',
    localizeDescription: 'DELIVERY_ATTEMPT',
    label: 'Delivery Attempt',
    localizeLabel: 'DELIVERY_ATTEMPT',
    icon_slug: 'icon-21',
    picture_url: '/img/accessorials/residential.png',
    include_in_offer: false,
    include_in_booking: false,
  },
  {
    value: 'hazmat',
    rate_to_carrier: 100,
    rate_to_shipper: 175,
    description: 'Hazardous Material',
    localizeDescription: 'HAZARDOUS_MATERIAL',
    label: 'Hazmat',
    localizeLabel: 'HAZMAT',
    icon_slug: 'icon-3',
    picture_url: '/img/accessorials/hazmat.png',
    dark_icon_slug_url: '/img/hazmat-accessorial.png',
    include_in_offer: true,
    include_in_booking: true,
  },
  {
    value: 'liftgate_origin',
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    description: 'Liftgate at Pickup',
    localizeDescription: 'LIFTGATE_AT_PICKUP',
    label: 'Liftgate',
    localizeLabel: 'LIFTGATE',
    icon_slug: 'icon-6',
    picture_url: '/img/accessorials/liftgate.png',
    dark_icon_slug_url: '/img/liftgate-accessorial.png',
    include_in_offer: false,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'pallet_jack',
    rate_to_carrier: 15,
    rate_to_shipper: 20,
    description: 'Pallet Jack',
    localizeDescription: 'PALLET_JACK',
    label: 'Pallet Jack',
    localizeLabel: 'PALLET_JACK',
    icon_slug: 'icon-6',
    picture_url: '/img/accessorials/pallet-jack.png',
    dark_icon_slug_url: '/img/pallet-jack.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'pallet_exchange',
    rate_to_carrier: 15,
    rate_to_shipper: 20,
    description: 'Pallet Exchange',
    localizeDescription: 'PALLET_EXCHANGE',
    label: 'Pallet Exchange',
    localizeLabel: 'PALLET_EXCHANGE',
    icon_slug: 'icon-6',
    picture_url: '/img/accessorials/pallet-jack.png',
    dark_icon_slug_url: '/img/pallet-jack.png',
    include_in_offer: true,
    meta_data: {
      pallets: {
        type: 'number',
        label: 'Number of Pallets',
      },
    },
  },
  {
    value: 'liftgate_destination',
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    description: 'Liftgate at Delivery',
    localizeDescription: 'LIFTGATE_AT_DELIVERY',
    label: 'Liftgate',
    localizeLabel: 'LIFTGATE',
    icon_slug: 'icon-6',
    picture_url: '/img/accessorials/liftgate.png',
    dark_icon_slug_url: '/img/liftgate-accessorial.png',
    include_in_offer: false,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'residential_delivery',
    rate_to_carrier: 25,
    rate_to_shipper: 35,
    description: 'Residential Delivery',
    localizeDescription: 'RESIDENTIAL_DELIVERY',
    label: 'Residential',
    localizeLabel: 'RESIDENTIAL',
    icon_slug: 'icon-3',
    picture_url: '/img/accessorials/residential.png',
    dark_icon_slug_url: '/img/residential-accessorial.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'inside_delivery',
    rate_to_carrier: 25,
    rate_to_shipper: 35,
    description: 'Inside Delivery',
    localizeDescription: 'INSIDE_DELIVERY',
    label: 'Inside Delivery',
    localizeLabel: 'INSIDE_DELIVERY',
    icon_slug: 'icon-3',
    picture_url: '/img/accessorials/residential.png',
    dark_icon_slug_url: '/img/residential-accessorial.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'mall',
    rate_to_carrier: 25,
    rate_to_shipper: 35,
    description: 'Mall',
    localizeDescription: 'MALL',
    label: 'Mall',
    localizeLabel: 'MALL',
    icon_slug: 'icon-4',
    picture_url: '/img/accessorials/residential.png',
    dark_icon_slug_url: '/img/residential-accessorial.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'school',
    rate_to_carrier: 25,
    rate_to_shipper: 35,
    description: 'School',
    localizeDescription: 'SCHOOL',
    label: 'School',
    localizeLabel: 'SCHOOL',
    icon_slug: 'icon-4',
    picture_url: '/img/accessorials/residential.png',
    dark_icon_slug_url: '/img/residential-accessorial.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'hotel',
    rate_to_carrier: 25,
    rate_to_shipper: 35,
    description: 'Hotel',
    localizeDescription: 'HOTEL',
    label: 'Hotel',
    localizeLabel: 'HOTEL',
    icon_slug: 'icon-4',
    picture_url: '/img/accessorials/residential.png',
    dark_icon_slug_url: '/img/residential-accessorial.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'airport_pickup',
    rate_to_carrier: 15,
    rate_to_shipper: 25,
    description: 'Airport Pickup',
    localizeDescription: 'AIRPORT_PICKUP',
    label: 'Airport',
    localizeLabel: 'AIRPORT_PICKUP',
    icon_slug: 'icon-8',
    picture_url: '/img/accessorials/airport.png',
    dark_icon_slug_url: '/img/airport-pickup.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
    required_documents: ['do', 'atme'],
  },
  {
    value: 'airport_delivery',
    rate_to_carrier: 15,
    rate_to_shipper: 25,
    description: 'Airport Delivery',
    localizeDescription: 'AIRPORT_DELIVERY',
    label: 'Airport',
    localizeLabel: 'AIRPORT_DELIVERY',
    icon_slug: 'icon-8',
    picture_url: '/img/accessorials/airport.png',
    dark_icon_slug_url: '/img/airport-pickup.png',
    include_in_offer: true,
    include_in_booking: true,
    shipper_can_book: true,
    required_documents: ['do', 'atme'],
  },
  {
    value: 'tsa_certification',
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    description: 'TSA Certification',
    localizeDescription: 'TSA_CERTIFICATION',
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-3',
    picture_url: '/img/accessorials/tsa.png',
    dark_icon_slug_url: '/img/tsa.png',
    include_in_offer: true,
    include_in_booking: true,
  },
  {
    value: 'room_of_choice',
    rate_to_carrier: 17.1,
    rate_to_shipper: 18.0,
    description: 'Room of Choice',
    localizeDescription: 'ROOM_OF_CHOICE',
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-16',
    picture_url: '/img/accessorials/residential.png',
    include_in_offer: false,
    include_in_booking: true,
  },
  {
    value: 'white_glove',
    rate_to_carrier: 29.93,
    rate_to_shipper: 31.5,
    description: 'White Glove',
    localizeDescription: 'WHITE_GLOVE',
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-24',
    picture_url: '/img/accessorials/residential.png',
    include_in_offer: false,
    include_in_booking: true,
  },
  {
    value: 'special_surcharge',
    rate_to_carrier: 22.5,
    rate_to_shipper: 30.0,
    description: 'Special Delivery',
    localizeDescription: 'SPECIAL_DELIVERY',
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-25',
    picture_url: '/img/accessorials/flatbed.png',
    include_in_offer: false,
    include_in_booking: true,
    shipper_can_book: true,
  },
  {
    value: 'fees_due',
    excludes: [],
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-25',
    picture_url: '/img/accessorials/cfs.png',
    description: 'Fees Due',
    localizeDescription: 'FEES_DUE',
    meta_data: {
      fees: {
        type: 'number',
        label: 'Fees Due',
        min: 1,
      },
    },
  },
  {
    value: 'over_500_weight',
    excludes: [],
    rate_to_carrier: 0,
    rate_to_shipper: 0,
    description: 'Over 500 Weight',
    localizeDescription: 'OVER_500_WEIGHT',
    label: '',
    localizeLabel: '',
    icon_slug: 'icon-26',
    picture_url: '/img/accessorials/cfs.png',
    meta_data: {
      weight: {
        type: 'number',
        label: 'Shipment Weight',
        min: 500,
      },
    },
  },
];

export const BOOKING_ACCESSORIALS = ACCESSORIALS.filter(
  (a) => a.include_in_booking,
);

export const BOOKING_ACCESSORIALS_MAP = BOOKING_ACCESSORIALS.reduce(
  (accessorialsMap, accessorial) => ({
    ...accessorialsMap,
    [accessorial.value]: {
      ...accessorial,
    },
  }),
  {},
);

const accessorialsMap = ACCESSORIALS.reduce(
  (runningMap, accessorial) => ({
    ...runningMap,
    [accessorial.value]: accessorial,
  }),
  {},
);

export default accessorialsMap;
